var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuw-study-inspirator vuw-background"},[_c('div',{staticClass:"vuw-header"},[_vm._t("header")],2),_c('div',{staticClass:"vuw-color-switch vuw-background-switch-reverse"},[_vm._t("main")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }